import { useState } from "react";
import AppSidebar, { SB_W, SB_W_COLLAPSED } from "../../../AppSidebar";
import ReportsView from "../../../ReportsView";
import "../styles/ReportsViewV2Page.css";

export default function ReportsViewV2Page({ showToast, user }) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(
    () => localStorage.getItem("sb-collapsed") === "true"
  );

  return (
    <div
      className="rpv2-root"
      style={{ gridTemplateColumns: sidebarCollapsed ? `${SB_W_COLLAPSED} 1fr` : `${SB_W} 1fr` }}
    >
      <AppSidebar
        user={user}
        collapsed={sidebarCollapsed}
        onCollapse={() => setSidebarCollapsed((c) => {
          const next = !c;
          localStorage.setItem("sb-collapsed", String(next));
          return next;
        })}
      />
      <div className="rpv2-main">
        <ReportsView showToast={showToast} user={user} />
      </div>
    </div>
  );
}
